import * as React from "react"
import { Link } from "react-router-dom";
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import { Typography } from "@mui/material";
import Table from 'react-bootstrap/Table';
import { isMobile } from "./mobile";
import ExpandableTable from "./expandableTable";

const OnlineClass = () => {
  const practiceTableRows=[{index: 1, title: "推薦", content: <Typography variant="body1">新人需由現有的夥伴推薦，推薦人負責對新人的日常禪修的鼓勵和督促，同時和小小群夥伴們保持信息溝通；請盡量推薦認識並有一定信任的，并且有意願學禪的人。</Typography> },
  {index: 2, title: "申請", content: <><Typography variant="body1">新人申請加入請填寫申請表</Typography><iframe width="640px" height="480px" src="https://forms.office.com/Pages/ResponsePage.aspx?id=sPynAndGTUW4l93t5we_U52q9gRZsTdAhY4Sni3QAmlUOFhJRzQ0VlRGSFI4TVdEM0E1WVpZQThaRi4u&embed=true" frameborder="0" marginwidth="0" marginheight="0" style={{border: "none", maxWidth:"100%", maxHeight:"100vh"}} allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen> </iframe></>},
  {index: 3, title:"課前準備", content: <Typography variant="body1">請提前下載并測試Zoom是否可用，更改Zoom名稱爲自己的姓名（與表格填寫的一致）。</Typography>},
  {index: 4, title: "上課", content: <Typography variant="body1"><ul><li>提交申請表格后的下一個周二上課，如果新人人數過多而做調整，我們會第一時間通知。</li>
  <li>請穿著舒適，寬鬆或者有彈性的褲子，在沒有風，溫暖的地方，坐在平坦的墊子（可以是瑜伽墊）上，不需要任何小坐墊。可以用薄毯蓋住腿</li>
    <li>上課時請打開攝像頭，并作簡短的自我介紹</li>
    <li>第一次上綫請在名字前面加上 N- 作爲新同學的標志，便於賢信師給予更多關注</li></ul></Typography>

},
  {index: 5, title: "課後", content: <Typography variant="body1">請按照賢信師的要求完成打坐練習，下次周二的課上給出反饋，推薦人負責情況跟蹤并在小小群發佈相關信息。</Typography>},
{index: 6, title: "成爲學員", content: <Typography variant="body1">參加了3次周二課程後可以加入小小群大家庭，禪修的路上我們相互幫助，共同成長。</Typography>}];


  let masterXChanClass=
  <div>
    <Typography variant="h1" style={{textAlign: "left"}}><b>賢信法師中文禪修班</b></Typography>
    <img src="/masterXChanClass.png" />
    <Typography variant="body1">這是一堂講中文的禪修課，有來自世界各地的人來參加。<br/>
賢信師每週二上午開課<br/><ul>
    <li>加州時間早上5:30</li>
    <li>北京時間晚上21:30</li>
    <li>美東時間早上8:30</li></ul><br/><br/>
報名須知<br/><br/>
各位小夥伴，賢信師的禪修課是我們學禪的出發點和加油站，照亮我們前進的方向；小小群是我們的樹洞和港灣，給我們溫暖和力量。爲了自助，也幫助他人得到禪修的利益，我們歡迎想加入禪修的新人加入。<br/><br/>
新學員加入的流程</Typography>
<ExpandableTable rows={practiceTableRows}/><br/>
  </div>;

  let masterZClass=
  <div>
    <Typography variant="h1">賢止師念咒講法Zoom課​</Typography><br/>
    <Stack direction="horizontal" gap={4}>
      <img src="/masterZZoomClass.jpeg" style={{top: "0px"}} />
      <Typography variant="body1">
        ​舊金山法藏寺的住持賢止法師開Zoom上的念咒課, 上課時間：<br/>
        <br/>
        <b>&emsp;韓國時間週三晚上8點 加州時間週三早上4點<br/></b>
        <br/>
        每一次課程有一小時聽師父講法和兩小時的念咒。<br/>
        <br/>
        這些課程有英語，越南語和韓文(有韓文的同聲傳譯)。你可以根據自己的時間加入和離開。<br/>
        <br/>
        Zoom鏈接<a href="https://us02web.zoom.us/j/88422874098?pwd=Zms5bUlvVHJpQXkzMnVoU0lZNCtsdz09" target="_blank">https://us02web.zoom.us/j/88422874098?pwd=Zms5bUlvVHJpQXkzMnVoU0lZNCtsdz09</a><br/>
        <br/>
        Zoom 會議 ID: 884 2287 4098<br/>
        密碼: respect<br/>
      </Typography>
    </Stack>
  </div>

  let masterXWBeginnerChanClass=
  <div>
    <Typography variant="h1" style={{textAlign: "left"}}>賢文師基礎禪修課</Typography>
    <Stack direction="horizontal" gap={4}>
      <img src="/masterXWChanClass.jpeg" width={345} maxWidth="100%" />
      <Typography variant="body1">
        這堂課主要說韓語，主要由賢文法師帶領
        <b>加州夏時製期間 韓國時間早上9-10點</b><br/>
        <b>加州標準期間 韓國時間早上10-11點</b><br/>
        <b>東部期間 晚上8點</b><br/>
        <b>西部時間 下午5點</b><br/>
        點擊<a href="https://us02web.zoom.us/j/8398759712?pwd=UnhwTzVlMUhjK1hlSmNaUmU5Y1p1UT09" about="_blank">這裡</a>加入Zoom會議或者輸入<br/>
        Zoom會議 ID:839 875 9712<br/>
        密碼: chan<br/>
      </Typography>
    </Stack>
  </div>

  let venXAEuropeanChanClass=
  <div>
    <Typography variant="h1" style={{textAlign: "left"}}>賢安法師歐洲禪修課</Typography>
    <Stack direction="horizontal" gap={4}>
      <img src="/venXAChanClass.jpeg" width={650} />
      <Typography variant="body1">
        歐洲禪修課（英文和西班牙語）
        由賢安法師教授，許多歐洲人參加
          <b>課程每週四9點 （CET,歐洲時間）</b><br/>
          <b>加州時間週四中午，紐約時間下午3點</b><br/>
        Zoom會議 ID:818 6210 0302
        密碼: sit<br/>
      </Typography>
    </Stack>
  </div>

  if(isMobile) {


    masterZClass=
    <div>
      <Typography variant="h1">賢止師念咒講法Zoom課​</Typography><br/>
      <img src="/masterZZoomClass.jpeg" />
      <Typography variant="body1">
        ​​舊金山法藏寺的住持賢止法師開Zoom上的念咒課, 上課時間：<br/>
        <br/>
        <b>&emsp;韓國時間週三晚上8點 加州時間週三早上4點<br/></b>
        <br/>
        每一次課程有一小時聽師父講法和兩小時的念咒。<br/>
        <br/>
        這些課程有英語，越南語和韓文(有韓文的同聲傳譯)。你可以根據自己的時間加入和離開。<br/>
        <br/>
        Zoom鏈接<a href="https://us02web.zoom.us/j/88422874098?pwd=Zms5bUlvVHJpQXkzMnVoU0lZNCtsdz09" target="_blank">https://us02web.zoom.us/j/88422874098?pwd=Zms5bUlvVHJpQXkzMnVoU0lZNCtsdz09</a><br/>
        <br/>
        Zoom 會議 ID: 884 2287 4098<br/>
        密碼: respect<br/>
      </Typography>
    </div>

    masterXWBeginnerChanClass=
    <div>
      <Typography variant="h1" style={{textAlign: "left"}}>賢文師基礎禪修課</Typography>
      <img src="/masterXWChanClass.jpeg" width={345} maxWidth="100%" />
      <Typography variant="body1">
        這堂課主要說韓語，主要由賢文法師帶領
        <b>加州夏時製期間 韓國時間早上9-10點</b><br/>
        <b>加州標準期間 韓國時間早上10-11點</b><br/>
        <b>東部期間 晚上8點</b><br/>
        <b>西部時間 下午5點</b><br/>
        點擊<a href="https://us02web.zoom.us/j/8398759712?pwd=UnhwTzVlMUhjK1hlSmNaUmU5Y1p1UT09" about="_blank">這裡</a>加入Zoom會議或者輸入<br/>
        Zoom會議 ID:839 875 9712<br/>
        密碼: chan<br/>
      </Typography>
    </div>

    venXAEuropeanChanClass=
    <div>
      <Typography variant="h1" style={{textAlign: "left"}}>賢安法師歐洲禪修課</Typography>
      <img src="/venXAChanClass.jpeg" width={650} />
      <Typography variant="body1">
        歐洲禪修課（英文和西班牙語）
        由賢安法師教授，許多歐洲人參加
          <b>課程每週四9點 （CET,歐洲時間）</b><br/>
          <b>加州時間週四中午，紐約時間下午3點</b><br/>
        Zoom會議 ID:818 6210 0302
        密碼: sit<br/>
      </Typography>
    </div>

  }

  return (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    src="/1337938998.jpg" />
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
      <Typography variant="h1">
      <strong>線上共修</strong>
      </Typography>
      <Typography variant="h6">
      我們有著豐富的網絡課程供大家根據自己的時間安排來做選擇
      </Typography><br/>

    {masterZClass}
    <hr style={{height:"1px"}}/>
    {masterXChanClass}
    <hr style={{height:"1px"}}/>
    {masterXWBeginnerChanClass}
    <hr style={{height:"1px"}}/>
    {venXAEuropeanChanClass}
  </Layout>
  </>
)
      }
/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */

export default OnlineClass;
